import React from "react";
import { SimpleGrid } from "@chakra-ui/react";
import KpiCard from "./KpiCard";

const KpiGrid = ({ items, isLoading }) => {
  const rows = isLoading ? Array.from({ length: 5 }) : items;

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 5 }} spacing={4} mb={6}>
      {rows.map((item, index) => (
        <KpiCard
          key={item?.key || index}
          label={item?.label}
          value={item?.value}
          helperText={item?.helperText}
          icon={item?.icon}
          tooltip={item?.tooltip}
          isLoading={isLoading}
        />
      ))}
    </SimpleGrid>
  );
};

export default KpiGrid;
